import PropTypes from "prop-types";
import React from "react";
import { communicationsAlerts } from "../../routes/AdminRoutes";
import { EmailAlerts } from "../../views/Communications";
import { Route } from "react-router-dom";

const AdminCommunications = () => {
  return (
    <>
      <Route path={communicationsAlerts} component={EmailAlerts} />
    </>
  );
};

AdminCommunications.propTypes = {
  match: PropTypes.any
};

export default AdminCommunications;
